export const getLiveShortName = (fullName: string) => {
  const names = fullName.split(" ");
    if (names.length > 1) {
        return `${names[0][0]}. ${names[1].substring(0, 8)}`;
    }
    return `${names[0].substring(0, 8)}`;
}